import { FC } from 'react'
import styled from 'styled-components'
import { useMenu } from 'hooks/hooks'
import { Apps } from '../../utils'
import { ButtonTabListItemProps, ButtonTabList } from '../tab/ButtonTabList'

const StyledMenuContainer = styled(ButtonTabList)`
    margin-left: 1.5rem;

    button[aria-selected='true'] {
        border-bottom: none;
    }
`

interface MenuProps {
    tabs: ButtonTabListItemProps[]
    app: Apps
}

export const MenuContainer: FC<MenuProps> = ({ tabs, app }) => {
    const [selectedTab, handleMenuNav] = useMenu(tabs, app)

    return (
        <StyledMenuContainer
            tabs={tabs}
            selectedTab={selectedTab}
            handleMenuNav={handleMenuNav}
            data-cy-menu
        />
    )
}
